export enum AddOnTypeModel {
  ROOM = "room",
  FOOD = "food",
  BEVERAGE = "beverage",
  OTHERS = "others",
}
